module.exports = __webpack_public_path__ + "img/99.4.8add35b1.png";